'use strict';
define(function() {

    /**
     * Attach analytics events
     */
    var analytics = {

        /**
         * @description ensure that element(s) passed are in array format for iteration in bind method
         * @param el
         * @returns {Array}
         */
        normaliseElements: function(el) {
            if (!el) {
                return [];
            }
            if (Array.isArray(el)) {
                return el;
            }
            if (!el.length && !Array.isArray(el)) {
                el = [el];
            }
            return el;
        },
        /**
         * @description add event listeners and associated data for event
         * @param el {Object}
         * @param actions {Object}
         */
        bind: function(el, actions) {
            var elements = analytics.normaliseElements(el);

            for (var iItem = 0; iItem < elements.length; iItem++) {
                var elItem = elements[iItem];
                if (!elItem.nodeName) {
                    throw new Error('element is not a DOM object');
                }
                for (var iAction = 0; iAction < actions.length; iAction++) {
                    var action = actions[iAction];
                    var data = (action.data) ? [action.data] : [elItem];
                    elItem.addEventListener(action.event, analytics.send(action.functionName, data));
                }
            }
        },
        /**
         * @description event listener function
         * @param functionName {String}
         * @param data {Object}
         * @returns {Function}
         */
        send: function(functionName, data) {
            return function() {
                try {
                    if (window[functionName]) {
                        window[functionName].apply(null, data);
                    }
                }
                catch (e) {
                    throw new Error(e.stack);
                }
            };
        }
    };

    return analytics;
});



// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/analytics.js